import instance from "./api";

export const bagManagers = () =>
  instance.get("/dashboard/bag-managers").then((r) => r.data ?? []);

export const bagManagersRequests = () =>
  instance.get("/dashboard/requests-bag-managers").then((r) => r.data);

export const updateBgManagersRequest = (id, body) => {
  console.log("Request Body:", body);

  return instance.patch(`/dashboard/${id}/bag-manager`, body);
};
